import BaseResource from './index'

export default class StateResource extends BaseResource {
    static endpoint = '/oasis/restv3/states'
}
